<div class="modal-header bg-light d-flex justify-content-center">
    <h4 class="modal-title text-center">Confirm bid<div class="h6 mb-0">{{'tenders.confirmBid'|cxTranslate}}</div>
    </h4>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<div *ngIf="!enableLoader">
    <div class="modal-body bg-light">
        <div>
            <h5 class="lg-semibold-font">{{productInfo?.newName?productInfo?.newName:productInfo?.productName}}</h5>
        </div>
        <div class="d-flex justify-content-between mt-2">
            <div class="small">
                <div class="small text-secondary">{{ 'tenders.Quantity(DMT)' | cxTranslate
                    }}({{productInfo.displayQuantityUnitDesc}})</div>
                <div class="strong small">{{quantityshw | number}}</div>
            </div>
            <div class="small">
                <div class="small text-secondary wrap">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
                <div class="strong small">{{productInfo?.laycanStartDate | date:"dd/MM/yyyy"}} -
                    {{productInfo?.laycanEndDate | date:"dd/MM/yyyy"}}</div>
            </div>
        </div>
        <div *ngIf="productInfo.childList == undefined">
            <div class="d-flex justify-content-between mt-2">
                <div class="small">
                    <div class="small text-secondary price-wrap">Your TC (per
                        {{productInfo.displayTCPriceConfig.displayTCPriceUnitDesc}})</div>
                    <div class="strong small">USD {{priceshw || '0'}}</div>
                </div>
                <div class="small" *ngIf="productInfo.displayRCPriceConfig.displayRCPrice == true">
                    <div class="small text-secondary wrap">Your RC (per
                        {{productInfo.displayRCPriceConfig.displayRCPriceUnitDesc}} of payable Copper)</div>
                    <div class="strong small">USD {{indexPriceshw || '0'}}</div>
                </div>
            </div>
            <div class="small mt-2">
                <div *ngIf="productInfo.baseKOP == 'BA CU'" class="small text-secondary">{{'tenders.QuotationPeriodCU'|
                    cxTranslate}} </div>
                <div *ngIf="productInfo.baseKOP == 'BA ZN'" class="small text-secondary">{{'tenders.QuotationPeriodZN'|
                    cxTranslate}}</div>
                <div *ngIf="productInfo.baseKOP != 'BA CU' && productInfo.baseKOP != 'BA ZN'" class="small text-secondary">
                    {{'tenders.QuotationPeriod'| cxTranslate}}</div>
                    <div *ngIf="productInfo.isQuotationPeriodUnrestricted == false && productInfo.pricingOptionsEnum[0].isQPMultipleChoicesSelected == false" class="small">{{formatQPDates(productInfo)}}
                    </div>
                        <div *ngIf=" productInfo?.isQPMultipleChoicesSelected == true" class="small">
                            <!-- {{data.pricingOptionsEnum[0] | json}} -->
                             <p *ngIf="productInfo.pricingOptionsEnum[0]?.qp[0].description != 'Fixed QP'">{{ productInfo.pricingOptionsEnum[0]?.qp[0].description}}</p>
                             <p *ngIf="productInfo.pricingOptionsEnum[0]?.qp[0].description == 'Fixed QP'">{{getDate(finalQPFromDate)}} - {{getDate(finalQPToDate)}} (both dates inclusive)</p>
                         </div>
                         <div *ngIf="productInfo.pricingOptionsEnum[0].isQPMultipleChoicesSelected == false && productInfo.pricingOptionsEnum[0].qp[0].description == 'Fixed QP' && productInfo.isQuotationPeriodUnrestricted==true" class="small">{{getDate(finalQPFromDate)}} -
                            {{getDate(finalQPToDate)}} (both dates inclusive)</div>
            </div>
            <!-- <div>
                    <div class="small text-secondary mt-2">{{'tenders.Pricingbasis'|cxTranslate}}</div>
                    <div class="small" *ngFor="let Pricingbasis of productInfo.pricingBasis">{{Pricingbasis?Pricingbasis.description:'--'}}</div>         
                </div> -->
                
            <div class="mt-2">
                <div class="small text-secondary ">{{'tenders.TermsAndconditions'|cxTranslate}}</div>
                <div class=" small">{{product.termsAndConditions?product.termsAndConditions.description:'--'}} </div>
            </div>
            <hr>
            <div class="mt-2" *ngIf="product.commodityType!= 'IO'">
                <p class="mb-2 small strong">{{'tenders.BuyerRemarks'|cxTranslate}}</p>
                <textarea class="w-100 form-control" maxlength="5000"
                    placeholder="{{ 'home.productHeader.bindingTermsPh' | cxTranslate }}"
                    [(ngModel)]="biddingTerms"></textarea>
            </div>
        </div>
        <div *ngIf="productInfo.childList!= undefined">
            <div *ngFor="let row of productInfo.childList">
                <div class="d-flex justify-content-between mt-2">
                    <div class="small">
                        <div class="small text-secondary price-wrap">{{row.productName}} TC (per
                            {{row.displayTCPriceConfig.displayTCPriceUnitDesc}})</div>
                        <div class="strong small">USD {{row.priceshw || '0'}}</div>
                    </div>
                    <div class="small" *ngIf="row.displayRCPrice == true">
                        <div class="small text-secondary wrap">{{row.productName}} RC (per
                            {{row.displayRCPriceConfig.displayRCPriceUnitDesc}} of payable Copper)</div>
                        <div class="strong small">USD {{row.indexPriceshw || '0'}}</div>
                    </div>
                </div>
                <!-- <div>
                        <div class="small text-secondary mt-2">{{'tenders.Pricingbasis'|cxTranslate}}</div>
                        <div class="small" *ngFor="let Pricingbasis of productInfo.pricingBasis">{{Pricingbasis?Pricingbasis.description:'--'}}</div>         
                    </div> -->
                <!-- <div>
                        <div class="small text-secondary mt-2">{{'tenders.QuotationPeriod'| cxTranslate}}</div>       
                        <div *ngIf="productInfo.isQuotationPeriodUnrestricted == false" class="small">{{formatQPDates(productInfo)}}</div>
                        <div *ngIf="productInfo.isQuotationPeriodUnrestricted == true"  class="small">{{getDate(finalQPFromDate)}} - {{getDate(finalQPToDate)}} (both dates inclusive)</div>
                    </div> -->
                <div id="23" class="mt-2">
                    <div class="small text-secondary ">{{'tenders.TermsAndconditions'|cxTranslate}}</div>
                    <div class=" small">{{product.termsAndConditions?product.termsAndConditions.description:'--'}} </div>
                </div>

            </div>

            <hr>
            <div class="mt-4" *ngIf="product.commodityType!= 'IO'">
                <p class="mb-2 small strong">{{'tenders.BuyerRemarks'|cxTranslate}}</p>
                <textarea class="w-100 form-control" maxlength="5000"
                    placeholder="{{ 'home.productHeader.bindingTermsPh' | cxTranslate }}"
                    [(ngModel)]="biddingTerms"></textarea>
            </div>
        </div>
    </div>

    <div class="modal-footer bg-light">
        <div class="w-100 text-center">
            <p class="mb-2 xs-semibold-font">{{confirmTxt}}</p>
        </div>
        <div class="w-100">
            <!-- <button class="btn btn-block btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0 || productInfo.priceValue < productInfo.minPrice"> -->
            <button class="btn btn-block btn-primary btn-lg" type="submit" (click)="submit()">
                {{ 'home.productHeader.ConfirmBid' | cxTranslate }}
            </button>
            <div class="d-flex justify-content-between mt-2">
                <button class="btn btn-light btn-lg button" type="button" (click)="backToPlacebid()">{{'tenders.Back'|
                    cxTranslate}}</button>
                <button class="btn btn-light btn-lg button" type="button" (click)="activeModal.dismiss('close click')"
                    data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
            </div>
        </div>
    </div>
</div>